import { matchPath } from 'react-router-dom';

export const isMatchRoute = (route, pathname) => {
  return matchPath(pathname, {
    path: route,
    exact: true,
    strict: false,
  });
};
